export default class EditorUI {
    highlightedElement;
    highlight(element) {
        this.removeHighlight();
        if (Array.isArray(element)) {
            element.forEach(element => {
                element.classList.add('highlighted-element');
            });
            this.highlightedElement = element;
        }
        else {
            element.classList.add('highlighted-element');
            this.highlightedElement = element;
        }
    }
    removeHighlight() {
        if (Array.isArray(this.highlightedElement)) {
            this.highlightedElement.forEach(element => {
                element.classList.remove('highlighted-element');
            });
        }
        else {
            if (this.highlightedElement)
                this.highlightedElement.classList.remove('highlighted-element');
            this.highlightedElement = null;
        }
    }
}
